"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ALL_APPOINTMENT_PERMISSIONS = exports.AppointmentPermissions = void 0;
/**
 * Permission string catalog for the Appointment bounded context
 * (Stage 5B.6). Format: `<module>:<action>`, same convention as
 * `platform.permissions.ts`/`patient.permissions.ts`. Added now,
 * additively — no permission catalog existed for Appointment before
 * this stage, since nothing needed RBAC gating until an HTTP layer
 * existed to gate. This file adds no new business rule; every
 * permission here gates a workflow whose rule already lives inside a
 * frozen Domain Service (Stage 5B.3) or Application Service (Stage
 * 5B.4).
 *
 * One permission per REST resource group (one per router), not per
 * individual operation — `appointment:book` covers all 8 booking
 * variants, `appointment:queue:manage` covers all 6 queue operations,
 * etc. — the same "collapse micro-actions into one permission"
 * convention `patient.permissions.ts` already established.
 */
exports.AppointmentPermissions = {
    APPOINTMENT_BOOK: 'appointment:book',
    APPOINTMENT_SCHEDULE_MANAGE: 'appointment:schedule:manage',
    APPOINTMENT_CHECK_IN: 'appointment:check-in',
    APPOINTMENT_QUEUE_MANAGE: 'appointment:queue:manage',
    APPOINTMENT_WAITLIST_MANAGE: 'appointment:waitlist:manage',
    APPOINTMENT_SLOT_MANAGE: 'appointment:slot:manage',
    APPOINTMENT_DOCTOR_AVAILABILITY_MANAGE: 'appointment:doctor-availability:manage',
    APPOINTMENT_REMINDER_MANAGE: 'appointment:reminder:manage',
    // Enterprise Architecture Handbook v1.0 (Appointment Administration, Module 2 — Appointment Sources).
    APPOINTMENT_BOOKING_CHANNEL_READ: 'appointment:booking-channel:read',
    APPOINTMENT_BOOKING_CHANNEL_MANAGE: 'appointment:booking-channel:manage',
};
/** Every Appointment permission, flattened — used to seed the `permissions` table. */
exports.ALL_APPOINTMENT_PERMISSIONS = Object.values(exports.AppointmentPermissions);
//# sourceMappingURL=appointment.permissions.js.map